// extracted by mini-css-extract-plugin
export default {"toggle":"_2Y7QR","tooltip":"_3M6LD","badge-icon":"_2saUw","badgeIcon":"_2saUw"};